<template>
	<div class="fullwidth fullheight ">


		<div class="fullwidth center  middle">

			


			<div class="uni-margin-wrap fullwidth " >

				<freeswiper :list="advList" :onClickImg="swiperClick"></freeswiper>


				<!-- <div v-if="swiperHeight==0" class="flex_center bg_jb25" :style="'height:'+swiperHeight_hold+'px;'">
					<img mode="widthFix" class="width40 autoheight " src="../../../assets/images/loading2.gif" />
				</div> -->

				
				<!-- <freeswiper :style="'height:'+swiperHeight+'px;'" class="swiper_box fullwidth autoheight " 
					:slides-per-view="1"
					:space-between="50"
					:pagination="{ clickable: true }"
					:navigation="true"
					:autoplay="{ delay: 3000 }" :xxx_autoplay="autoplay" 
					:loop="true"
					
					circular
					:indicator-dots="indicatorDots" :display-multiple-items="display_multiple_items"
					:interval="interval" :duration="duration">
					<swiper-slide v-for="(item, index) in advList" @click="swiperClick(item)" :key="index">
						<img :id="'swiperimage'+index" class=" fullwidth autoheight"
							mode="widthFix" :src="item.img" />
						<div class="hidden fullwidth maxheight500 height750r"
							:style="'background-image:url('+item.img+');background-position:center center;background-size:100% auto;background-repeat:no-repeat;' ">
						</div>
					</swiper-slide>
				</freeswiper> -->
			</div>
		</div>



<!-- 广告词wenzi -->
		<div v-if="!!adv_word==true" class=" fullwidth   relative">
				<div class=" padding0">
					<div class="flex_center relative height35">
						<div class="borderb width90p automargin"></div>
						<div class="absolute automargin radius20 space10 lineh35 paddingl30 paddingr20 center size3 color2 border bg_white width250">{{adv_word}}</div>
					</div>
					<div class="space5 paddingl5 center color3 size5 ">
						{{adv_word_s}}
					</div>
				</div>
			</div>


		<!-- 当前店铺 -->
		<div class="bg_fff margin15 radius10 padding5">
			<div class="flex_row  padding0">
				<div @click="toShopList" class="uni-icon uni-icon-location paddingl10"></div>
				
				<div @click="toShopList" class="paddingl10 fullwidth minwidth0">
					<div class="size4 color1">{{selectedShop.name}}</div>
					<div class="hidden">{{selectedShop.area}}{{selectedShop.address}}</div>
					<div class="hidden inline padding10 bg_red1 color5 radius10">更换店铺</div>
				</div>
				<div @click="toShopList" class="uni-icon uni-icon-arrowright"></div>
			</div>
		</div>


		<!-- 推荐商品 -->
		<div class="fullwidth  size0 padding015 ">

			<div v-for="(item,index) in recommendList" @click="toGoodsDetail(item.id)" v-bind:key="index"
				:class="item_style_Width+' relative inline padding5 bg_white  lineh1 overhide '">
				<img mode="widthFix" class="  fullwidth autoheight " :src="item.imgArr[0]" />
				
				 <div class="absolute top10 right10 right">
					 <div class=" paddingl10 paddingr10 paddingt5 lineh130p paddingb5 radius5 size5 color5 bg_red inline">推荐</div>
					<div class="hidden">{{item.name}}</div>
					<div class="">￥{{item.minPrice}}</div>
				</div>
			</div>
			

			<div v-for="(item,index) in hotList" @click="toGoodsDetail(item.id)" v-bind:key="index"
				:class="item_style_Width+' relative inline padding5 bg_white lineh1  overhide '">
				<img mode="widthFix" class="  fullwidth autoheight " :src="item.imgArr[0]" />
				
				 <div class="absolute top10 right10 right">
					 <div class=" paddingl10 paddingr10 paddingt5 lineh130p paddingb5 radius5 size5 color5 bg_green inline">热卖</div>
					<div class="hidden">{{item.name}}</div>
					<div class="">￥{{item.minPrice}}</div>
				</div>
			</div>
			

		</div>



		<div class="fullwidth hidden">
			<div class="fullwidth  ">
				<block v-for="(item, index) in listData" :key="index">
					<div class="marginb10 bg_white" hover-class="uni-list-cell-hover">
						<div class="flex_row">

							<img @click="orderConfirm(item)" class="width200r height200r minwidth200r"
								mode="aspectFill" :src="item.imgArr[0]" />

							<div class="marginl10 fullwidth">
								<div @click="orderConfirm(item)" class="flex_row padding0">
									<div class="size3 ">{{ item.name }}</div>
									<span class="size3 color_red">￥{{ item.price}}</span>
								</div>
								<div class="flex_row padding0 margint20">

									<div @click="orderConfirm(item)" class="width50p middle  size4 color2">
										仅剩{{ item.supplyCount }}</div>

									<div class="height50 nowrap flex_row_s padding0 autowidth">
										<div v-if="item.orderCount>0" @click="changeCount(1,index)"
											class="uni-icon uni-icon-minus-filled   middle inline color_orange  bold size1">
										</div>
										<div v-if="item.orderCount>0"
											class="radius5 middle inline  border color_red width40 height40 margin5 lineh40 center">
											{{item.orderCount?item.orderCount:0}}
										</div>
										<div @click="changeCount(2,index)"
											class="uni-icon uni-icon-plus-filled  middle inline color_green  bold size1 ">
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>

				</block>
			</div>
			<uni-load-more :status="status" :icon-size="16" />
		</div>

		



		<!-- 弹窗 -->
		<uni-popup ref="operate_popup" background-color="#fff" @change="popChange">
			<div v-if="popEvent=='select_shop'" class="width300 padding20 center">
				<div class="size3">
					请先选择附近的店铺
				</div>
				<div class="margint40r bg_orange padding10 color5 fullwidth radius40r">去选店铺</div>
			</div>
			<div v-if="popEvent=='to_browser'" class="width300 padding20 center">
				<div class="size2  bold">
					请在浏览器打开网站
				</div><div class="size4 color_red">
					（因微信拦截了支付宝）
				</div>
				<div @click="copyToBoard()" class="color5 bg_blue margint40r center  padding10 color1 fullwidth ">
					{{host}}  复制 
				</div>
				<!-- <div class="left margint40r   padding10 color1 fullwidth ">方法1：复制网址，在浏览器打开</div> -->
				<div class="left   padding10 color1 fullwidth  ">
					点右上角按钮，选
					<span class=" color_blue ">在浏览器打开</span>
					
				</div>
			</div>
		</uni-popup>


		
		<!-- 预览模态框 -->
		<div v-if="showPreview" class="image-preview-modal" @click="closePreview">
			<div class="preview-content" @click.stop>
				<button class="close-btn" @click="closePreview">×</button>
				<img :src="currentImage" class="preview-img">
			</div>
		</div>


	</div>
</template>

<script>
	// 组件内引入
	import freeswiper from '@/components/freeswiper/freeswiper.vue';
import uniPopup from '@/components/uni-popup/uni-popup.vue';
	// import uniLoadMore from '@/components/uni-load-more/uni-load-more.vue';
	// import uniPopup from "@/components/uni-popup/uni-popup";
	// var app = getApp();
	var swiperimgindex = 0;

	export default {
		components: {
			// uniLoadMore
			// uniPopup
			freeswiper,uniPopup
		},
		data() {
			return {
				popEvent:"",
				popType:"center",
				adv_word: "",
				adv_word_s: "",
				logo:"",

				host: "",
				selectedShop: {},
				listData: [],
				page: 1,
				totalPage: 0,
				status: '',

				//广告
				advList: [],
				indicatorDots: true,
				autoplay: true,
				interval: 2000,
				duration: 500,
				display_multiple_items: 1,
				swiperHeight: 0,
				swiperHeight_hold:200,//广告位预留高度


				hotList: [],
				recommendList: [],
				windowWidth:0,
				
				item_style_Width:"width50p",
				swiperimage_maxwidth:700,//图片最大宽度，超过即多图
				
				//看图
				showPreview: false,
      			currentIndex: 0,
				imgurls:[],
			};
		},
		onShareAppMessage() {
			return {
				title: '欢迎体验',
				path: '/pages/goods/list/list'
			}
		},
		onNavigationBarButtonTap(e) {
			this.$router.push({ path: '/' }); 
		},

		computed: {
			currentImage() {
				if(this.advList.length>0)return this.advList[this.currentIndex].img;
			}
		},

		created() {

			var that = this;
			this.host = window.$config.host;
			window.$utils.uniapi.setNavigationBarTitle({ title:window.$config.appName });
			
			
			var info=window.$utils.uniapi.getSystemInfoSync();
			this.windowWidth=info.windowWidth;
			if(this.windowWidth>this.swiperimage_maxwidth){
				this.item_style_Width="width25p";
			}
			
			if(info.windowWidth<info.windowHeight){
				this.swiperHeight_hold=info.windowWidth;
			}
			
			//选择店铺
			this.selectedShop = window.$utils.uniapi.getStorageSync("selectedShop") || {};
			console.log("onLoad",  this.selectedShop);
			if (!!this.selectedShop==false || typeof this.selectedShop.id == "undefined") {
				//this.$refs.my_popup.open("center");
				window.$utils.uniapi.showToast({ title: "请先选择附近的店铺", icon: "none" })
				this.$router.push({ name: "shop_list",query:{action:"select_shop"} });
				return;
			}
			
			
			
			
			this.checkUserLoginState(function(res) {
				if(res){
					//用户已登录且正常
					that.loadData();
				}else{
					//用户未登录
					// #ifdef MP
						//采用wx-code登录
						// app.wxLogin(function() {
						// 	that.loadData();
						// });
					// #endif
					
					// #ifndef MP
						//暂不登录，后续择机登录
						that.loadData();
					// #endif
				}
				
			});
			

			this.adv_word = window.$config.adv_word;
			this.adv_word_s = window.$config.adv_word_s;
			this.logo = window.$config.logo;
			console.log(this.adv_word);
			
			// //在微信浏览器
			// if(this.isWeChatBrowser()){
			// 	//弹窗
			// 	this.popEvent="to_browser";
			// 	this.popOpen("center");
			// }

		},
		mounted() {
			console.log("onShow start");
			

		},
		onPullDownRefresh() {
			this.page = 1;
			//this.getList();
			window.$utils.uniapi.stopPullDownRefresh();
		},
		onReachBottom() {
			this.status = this.page >= this.totalPage ? "nomore" : 'more';
			if (this.page < this.totalPage) {
				this.page++;
				//this.getList();
			}
		},
		methods: {

			loadData() {
				console.log("loadData",this.swiperHeight);
				this.page = 1;
				this.getList("hot,recommend");
				this.getAdvList();
				this.countCart();
				
				
				

			},
			
			// 点击事件触发复制
			copyToBoard(text) {
				try{
					if(window && !!text==false){
						text=window.location.href;
					}
				}catch(e){
					console.log(e);
				}
				
				window.$utils.uniapi.setClipboardData({
					data: text,
					success: () => {
					  window.$utils.uniapi.showToast({ title: '复制成功', icon: 'none' });
					},
					fail: (err) => {
					  console.error('复制失败:', err);
					}
				});
			},

			/**
			 * 是否为微信浏览器，h5支付因支付宝不支持微信，需跳出
			 */
			isWeChatBrowser() {
				// #ifdef H5
				const ua = window.navigator.userAgent.toLowerCase();
				return ua.indexOf('micromessenger') !== -1;
				// #endif
				return false;
			  
			},
			
				
			popChange(e) {
				console.log('当前模式：' + e.type + ',状态：' + e.show);
				if(!e.show)this.fnTree=[];//关闭时清除
				
			},
			popOpen(type) {
				this.popType = type;
				// open 方法传入参数 等同在 uni-popup 组件上绑定 type属性
				this.$nextTick(() => {
					this.$refs.operate_popup.open(type);
				});
			},
			popClose(){
				if(this.$refs.operate_popup)this.$refs.operate_popup.close();
			},

			swiperImgLoad(e) {
				// console.log("图片加载完成", e);
				// if (swiperimgindex == 0) {
				// 	swiperimgindex++;
				// 	// this.swiperHeight=e.detail.height;
				// 	var swiperImgWhb = e.detail.width / e.detail.height;

				// 	var that = this;
				// 	var query = window.$utils.uniapi.createSelectorQuery(); //，创建节点选择器后，调用 
				// 	query.select('#swiperimage0').boundingClientRect().exec((res) => {
				// 		console.log("---------", res, swiperImgWhb);
				// 		var imgInfo = res[0];
				// 		if (imgInfo == null) return;
				// 		var swiperHeight = imgInfo.width / swiperImgWhb;
				// 		if (imgInfo.width > 600) {
				// 			this.display_multiple_items = 2;
				// 		} else {
				// 			this.display_multiple_items = 1;
				// 		}
				// 		this.swiperHeight = swiperHeight / this.display_multiple_items;
				// 	}); // 方法，获取该图片的具体信息
				// }

			},
			//依图片设置容器高度
			setBoxHeightByImg(swiperImgWhb){
				var that = this;
				var swiperHeight=$('.swiper_box').width();
				this.swiperHeight = swiperHeight / this.display_multiple_items;

				// var query = window.$utils.uniapi.createSelectorQuery(); //，创建节点选择器后，调用 
				// query.select('#swiperimage0').boundingClientRect().exec((res) => {
				// 	console.log("查询图片实际显示大小", res, swiperImgWhb);
				// 	var imgInfo = res[0];
				// 	if (imgInfo == null) return;
				// 	var swiperHeight = imgInfo.width / swiperImgWhb;
				// 	if (imgInfo.width > this.swiperimage_maxwidth) {
				// 		this.display_multiple_items = 2;
				// 	} else {
				// 		this.display_multiple_items = 1;
				// 	}
				// 	this.swiperHeight = swiperHeight / this.display_multiple_items;
				// 	console.log("轮播图数量"+this.display_multiple_items);
				// }); // 方法，获取该图片的具体信息
			},
			getImageInfo(url) { 
				var that=this;
				// #ifdef H5
					const image = new Image();
					image.onload = () => {
						that.imageInfo = {
							width: image.width,
							height: image.height,
							type: image.type
						};
						console.log("获取图片信息h5",that.imageInfo);
						
						var swiperImgWhb = that.imageInfo.width /that.imageInfo.height;
						that.setBoxHeightByImg(swiperImgWhb);
					};
					image.src = url;
				// #endif
				
				// #ifndef H5
					window.$utils.uniapi.getImageInfo({
							src: url,
							success: function (image) {
								console.log(image.width);
								console.log(image.height);
								that.imageInfo = {
									width: image.width,
									height: image.height,
									type: image.type
								};
								console.log("获取图片信息MP",that.imageInfo);
								var swiperImgWhb = that.imageInfo.width /that.imageInfo.height;
								that.setBoxHeightByImg(swiperImgWhb);
							},
							fail(res) {
								console.log(res);
							}
						});
				// #endif
				
				
				
			},
			  
			// //设置高度
			// setHeight() {
			// 	//页面可见区域高度
			// 	let windowHeight = window.$utils.uniapi.getSystemInfoSync().windowHeight;
			// 	console.log("页面可见区域 " + windowHeight);
			// 	//获取节点代码
			// 	var query = window.$utils.uniapi.createSelectorQuery();
			// 	//获取节点
			// 	query.select('#my_swiper').boundingClientRect(res => {
			// 		//判断是否未true
			// 		if (res) {
			// 			//当前元素高度
			// 			console.log("元素高度 = " + rect.height);
			// 			//页面高度+循环体高度等于总高度
			// 			this.height = windowHeight + rect.height;
			// 			console.log("总高度为 = " + this.height)
			// 		}
			// 	}).exec();
			// },


			

			popChange() {

			},
			createOrder() {
				console.log("createOrder");

			},
			changeCount(action, index) {
				console.log(action, index);
				if (action === 1) {
					var c = this.listData[index].orderCount ? this.listData[index].orderCount - 1 : 0;
					this.listData[index].orderCount = c >= 0 ? c : 0;
				} else {
					var c = this.listData[index].orderCount ? this.listData[index].orderCount + 1 : 1;
					this.listData[index].orderCount = c <= this.listData[index].supplyCount ? c : this.listData[index]
						.supplyCount;
				}
				this.$forceUpdate();
			},

			toDetail: function(e) {
				console.log(e);
				window.$utils.uniapi.showModal({
					title: "扫码支付"
				})
				// window.$utils.uniapi.navigateTo({
				// 	url: '/pages/goods/detail?id='+e.id //+'&detailDate=' + encodeURIComponent(JSON.stringify(detail))
				// });
			},

			//订购确认
			orderConfirm(item) {
				var that = this;
				window.$utils.uniapi.showModal({
					title: item.name + " 1份",
					content: "请支付金额" + item.price + "元，谢谢",
					cancelText: "取消",
					confirmText: "付款码支付",
					success(res) {
						if (res.confirm) {
							that.scanCode();
						} else {
							console.log("close");
						}
					}
				})
			},
			//扫码
			scanCode() {
				// 允许从相机扫码
				window.$utils.uniapi.scanCode({
					onlyFromCamera: true,
					success: function(res) {
						console.log('条码类型：' + res.scanType);
						console.log('条码内容：' + res.result);
					}
				});
			},




			getAdvList() {
				var that = this;
				if(typeof this.selectedShop.id=='undefined'){
					console.log("查询商品:  无店");
					return;
				}
				var params = {
					position: window.$config.advPosition.index //"xs_wxmp_index_top"
				};


				that.$axios.request( {url: window.$config.url.getAdvList,  data: params })
				.then(res => {
					window.log(JSON.stringify(res));
					//if(!that.commonResponse(response))return;
					if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
						let list = res.data;
						this.advList = this.page == 1 ? list : this.advList.concat(list);
						this.getImageInfo(this.advList[0].img);

						//看图urls
						var imgurls=[];
						for(var i=0;i<this.advList.lenght;i++){
							imgurls.push(this.advList[i].img);
						}
						this.imgurls=imgurls;

					} else if (!!res.msg == true) {
						window.$utils.uniapi.showToast({ title: res.msg, icon: "none" });
					} else {
						window.$utils.uniapi.showToast({ title: "不成功", icon: "none" });
					}
					// if(response && response.data && response.data.code==0){
					//   window.showToast({title:"成功"});
					// }
				})
				.catch(error => {
					window.log(error);
					alert("不成功");
				});

       

				// this.$axios.request({
				// 		url: window.$config.url.getAdvList,
				// 		data: params
				// 	})
				// 	.then(res => {
				// 		if (!!res.code == true && res.code == window.$config.resCode.SUCCESS) {
				// 			let list = res.data;
				// 			this.advList = this.page == 1 ? list : this.advList.concat(list);
				// 			this.getImageInfo(this.advList[0].img)
				// 		} else if (!!res.msg == true) {
				// 			window.$utils.uniapi.showToast({ title: res.msg, icon: "none" });
				// 		} else {
				// 			window.$utils.uniapi.showToast({ title: "不成功", icon: "none" });
				// 		}
				// 	});

			},

			swiperChange: function(e) {
				//	eventhandle 		否 	current 改变时会触发 change 事件，event.detail = { current, source }
				//console.log(e.detail);
				this.advIndex = e.detail.current;
			},
			swiperClick: function(currentIndex) {	//传入序号
				console.log("swiperClick1", currentIndex, this.advList );
				
				var goodsId= this.advList[currentIndex].link;
				console.log(goodsId)
				if (!!goodsId == true) {
					//导航到商品
					this.$router.push({ path: '/goods_detail',query:{'id': goodsId}  });
					return;
				}
				
				this.openPreview(currentIndex);
			},
			openPreview(index) {
				console.log("openPreview "+index);
				this.currentIndex = index
				this.showPreview = true
				// 阻止背景滚动
				document.body.style.overflow = 'hidden'
			},
			closePreview() {
				this.showPreview = false
				document.body.style.overflow = 'auto'
			},


			toShopList() {
				this.$router.push({
					path: "/shop_list" //?action=select_shop"
				})
			},

			toGoodsList() {
				window.$utils.uniapi.switchTab({
					url: "/pages/tabbar/goods/index"
				})
			},
			//更新购物车提示
			countCart() {
				var totalCount = 0;
				var totalAmount = 0;
				var cartGoodsList = window.$utils.uniapi.getStorageSync('cartGoodsList') || [];
				//更新统计
				for (var i = 0; i < cartGoodsList.length; i++) {
					console.log('cartGoodsList[i].goodsSpecList ', cartGoodsList[i].goodsSpecList);
					for (var p = 0; p < cartGoodsList[i].goodsSpecList.length; p++) {
						if (cartGoodsList[i].goodsSpecList[p].currOrderCount <= 0) continue;
						totalCount += cartGoodsList[i].goodsSpecList[p].currOrderCount;
						totalAmount += cartGoodsList[i].goodsSpecList[p].currOrderCount * cartGoodsList[i].goodsSpecList[p]
							.price;
					}
				}
				//window.$utils.uniapi.setStorageSync('cartGoodsList', cartGoodsList);
				//提示
				// if (totalCount > 0) {
				// 	console.log("购物车提示", totalCount);
				// 	window.$utils.uniapi.setTabBarBadge({ index: 2, text: '' + totalCount });
				// } else {
				// 	window.$utils.uniapi.removeTabBarBadge({ index: 2 });
				// }
				// window.$store.state.cartGoodsCount=totalCount;
				window.$store.commit('setCartGoodsCount', totalCount);
				//this.totalCount = totalCount;
				//this.totalAmount = totalAmount.toFixed(2);
			},


			getToken(callback) {
				var user = window.$utils.uniapi.getStorageSync("user");
				if (!!user == false) {
					console.log(user, "user none");
					if (typeof callback == 'function') {
						callback();
					}
					return;
				}

				this.$axios.request( {url: window.$config.url.getToken,  data: { uid: user.id } })
					.then(res => {
						window.log(JSON.stringify(res));
						//if (!this.commonResponse(response)) return;
						if (res && res.code == window.$config.resCode.SUCCESS) {
							//window.$utils.uniapi.showToast({ title: res.data.msg, icon: "success" });
							user.token = res.data;
							window.$utils.uniapi.setStorageSync("user", user);
						} else if (res && res.msg) {
							window.$utils.uniapi.removeStorageSync("user");
							//window.$utils.uniapi.showToast({ title: res.data.msg, icon: "none" });
						} else {
							window.$utils.uniapi.removeStorageSync("user");
							//window.$utils.uniapi.showToast({ title: "不成功", icon: "none" });
						}
						if (typeof callback == 'function') { callback(); }
					})
					.catch(error => {
						window.log(error);
						console.log("error=" + error)
						//window.$utils.uniapi.showToast({ title: error, icon: "none" });
						window.$utils.uniapi.removeStorageSync("user");
						if (typeof callback == 'function') { callback(); }
					});

				
			},
			checkUserLoginState(callback) {
				var user = window.$utils.uniapi.getStorageSync("user");
				if (!!user == false) {
					console.log(user, "user none");
					if (typeof callback == 'function') { callback(false); }
					return;
				}
				this.$axios.request( {url: window.$config.url.checkUserLoginState,  data: { } })
					.then(res => {
						window.log(JSON.stringify(res));
						//if (!this.commonResponse(response)) return;
						if (res && res.code == window.$config.resCode.SUCCESS) {
							if (typeof callback == 'function') { callback(true);return; }
						} else if (res && res.msg) {
							window.$utils.uniapi.removeStorageSync("user");
						} else {
							window.$utils.uniapi.removeStorageSync("user");
						}
						if (typeof callback == 'function') { callback(false); }
					})
					.catch(error => {
						window.log(error);
						window.$utils.uniapi.removeStorageSync("user");
						if (typeof callback == 'function') { callback(false); }
					});

			},
			/**
			 * 
			 */
			getList: function(showType) {
				console.log("查询商品");
				var that = this;
				if(typeof this.selectedShop.id=='undefined'){
					console.log("查询商品:  无店");
					return;
				}
				var params = {};
				if (!!showType == true) {
					params.showType = showType;
				}
				that.$axios.request( {url: window.$config.url.getGoodsList,  data: params })
					.then(res => {
						window.log(JSON.stringify(res));
						if (res && res.code == window.$config.resCode.SUCCESS) {
							var list = res.data.list;

							console.log(list);

							if (list.length == 0) {
								//wx.showToast({ title: '没有数据',image: '../../images/warn.png' });
							}
							var hotList = that.paresData(list, "hot");
							var recommendList = that.paresData(list, "recommend");
							//that.makeSpecItemList(list);//提取规格
							that.hotList = hotList;
							that.recommendList = recommendList;

							//初始商品选中数量
							//that.initSelectedGoods();

							//that.getCartList();
						}
					})
					.catch(error => {
						window.log(error);
					});
			},
			paresData(list, showType) {
				var d = [];
				for (var i = 0; i < list.length; i++) {
					if (list[i].showType == showType) {
						list[i].img = list[i].img.replace("10.0.2.2", "localhost");
						d.push(list[i]);
					}
				}
				return d;
			},
			
			toGoodsDetail(id){
				this.$router.push({path:"/goods_detail",query:{ id:id }});
			}

		}
	};
</script>

<style scoped>


/* 看图 */
.image-preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.preview-content {
  position: relative;
  max-width: 100%;
  max-height: 100%;
}

.preview-img {
  width: 100%;
  height: auto;
  display: block;
}

.close-btn {
  position: absolute;
  top: 0;
  right: 0;
  background: #fff;opacity: 0.6;
  border: none;
  color: #000;
  font-size: 30px;
  height: 40px;width:40px;border-radius: 50%;
  cursor: pointer;line-height: 1;
	text-align: center;
}

/* swiper start  */
.swiper-container {
  width: 100%;
  height: 400px;
}

.slide-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.slide-content img {
  width: 100%;
  height: 300px;
  object-fit: cover;
}

/* 自定义分页器样式 */
:deep(.swiper-pagination-bullet) {
  width: 12px;
  height: 12px;
  background: #fff;
  opacity: 0.5;
}

:deep(.swiper-pagination-bullet-active) {
  background: #007aff;
  opacity: 1;
}

/* 自定义导航按钮 */
:deep(.swiper-button-next),
:deep(.swiper-button-prev) {
  color: #007aff;
}
/* swiper end */
	.banner {
		height: 180px;
		overflow: hidden;
		position: relative;
		background-color: #ccc;
	}

	.banner-img {
		width: 100%;
	}

	.banner-title {
		max-height: 42px;
		overflow: hidden;
		position: absolute;
		left: 15px;
		bottom: 15px;
		width: 90%;
		font-size: 16px;
		font-weight: 400;
		line-height: 21px;
		color: white;
		z-index: 11;
	}



	.uni-media-list-body {
		height: auto;
		justify-content: space-around;
	}

	.uni-media-list-text-top {
		overflow: hidden;
	}

	.uni-media-list-text-bottom {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.title_text {
		margin: 0px auto;
		width: 100%;
		text-align: center;
	}

	.title_text_en {
		width: 100%;
		text-align: center;
		padding: 6px 0;
		font-size: 18px;
		letter-spacing: 5px;
		text-indent: 0px;
	}
</style>


// WEBPACK FOOTER //
// src/views/tabbar/index/index.vue